import { render, staticRenderFns } from "./BottomNavigationBar.vue?vue&type=template&id=8ee88c22&scoped=true"
import script from "./BottomNavigationBar.vue?vue&type=script&lang=js"
export * from "./BottomNavigationBar.vue?vue&type=script&lang=js"
import style0 from "./BottomNavigationBar.vue?vue&type=style&index=0&id=8ee88c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee88c22",
  null
  
)

export default component.exports